import React from 'react';
import MapSectionHeader from './MapSectionHeader';
import MapSection from './MapSection';

export interface DispatchMapProps {
  contentWrapperClassName?: string;
}

const DispatchMap = ({ contentWrapperClassName }: DispatchMapProps) => (
  <>
    <MapSectionHeader />
    <div className={contentWrapperClassName}>
      <MapSection />
    </div>
  </>
);

export default DispatchMap;
